import MicroModal from 'micromodal';

jQuery(document).ready(function($) {

    /*
        * set all favorites of the user as selected
        */
    $(document).on("wpgu-set-favorites-selected", function() {
        if ($('[data-wpgu-favorite-btn]').length) {
            var favorite_posts = $('body').data('wpgu-favorite-posts');

            $.each(favorite_posts, function(index, value) {
                $('[data-wpgu-favorite-id="' + value + '"]').each(function() {
                    if (!$(this).hasClass('selected')) {
                        $(this).addClass('selected');
                    }
                });
            });

            $(document).trigger("wpgu-favorites-marked-selected");
        }
    });

    /*
    * Update the favorite ids
    */
    $.ajax({
        url      : wpguvars.ajaxurl,
        data     : {
            action  : 'wpgu_get_account_info',
        },
        type     : 'POST',
        dataType : 'json'
    }).done(function(result) {
        if (true !== result.success) {
            return;
        }

        if (result.data.favorite_ids && $.isArray(result.data.favorite_ids)) {
            $('body').data( 'wpgu-favorite-posts', result.data.favorite_ids );
            $(document).trigger( "wpgu-set-favorites-selected" );
        }
    });


    /*
        * Add/Remove post to favorite list using AJAX
        */
    $('body').on('click', '[data-wpgu-favorite-btn]', function(e) {
        e.preventDefault();

        var $fav_button = $(this);
        var id          = $fav_button.data('wpgu-favorite-id');
        var label       = $fav_button.data('wpgu-favorite-label');
        var toggled     = $fav_button.data('wpgu-favorite-toggled');

        if( toggled == true ) {
            return false;
        }

        $fav_button.data('wpgu-favorite-toggled', true);

        $('[data-wpgu-favorite-id="' + id + '"]').toggleClass('selected');
        $(document).trigger('wpgu-favorite-btn-clicked', [$fav_button]);

        $.ajax({
            url      : wpguvars.ajaxurl,
            data     : {
                action  : 'wpgu_toggle_favorite',
                post_id : id,
                current_url : window.location.protocol + '//' + window.location.hostname + window.location.pathname,
            },
            type     : 'POST',
            dataType : 'json'
        }).done(function(result) {

            $fav_button.data('wpgu-favorite-toggled', false);

            if (result.data.favorite_added) {
                $(document).trigger("wpgu-favorite-added", [id]);
            }

            if (result.data.favorite_removed) {
                $(document).trigger("wpgu-favorite-removed", [id]);
            }

            if (result.data.modal) {
                // remove the popup if it already exists
                if ($('#' + result.data.modal_id).length) {
                    $('#' + result.data.modal_id).remove();
                }

                // add modal to body
                $('body').append(result.data.modal);
                MicroModal.show(result.data.modal_id);

                if (true !== result.data.logged_in) {
                    window.wpguGtmTrackEvent('wpgu-favorite-button', 'not logged in click', label);
                } else if(!result.data.nawnr) {
                    window.wpguGtmTrackEvent('wpgu-favorite-button', 'not subscriber click', label);
                } else if(true !== result.data.has_subscription_access) {
                    window.wpguGtmTrackEvent('wpgu-favorite-button', 'old subscriber click', label);
                }

                // unselect the favorite buttons
                $('[data-wpgu-favorite-id="' + id + '"]').toggleClass('selected');

                return;
            }

            if (result.data.favorite_ids != null) {
                $('body').data('wpgu-favorite-posts', result.data.favorite_ids);
            }

            if (result.data.favorite_removed) {
                if ($('[data-wpgu-favorite-posts-container]').length) {
                    if ($('[data-wpgu-favorite-posts-container]').find('[data-wpgu-favorite-post="' + result.data.favorite_removed + '"]').length) {
                        $('[data-wpgu-favorite-posts-container]').find('[data-wpgu-favorite-post="' + result.data.favorite_removed + '"]').remove();
                        $(document).trigger("wpgu-set-favorites-selected");

                        if ($('a[data-wpgu-favorite-load-more]').length) {
                            $('a[data-wpgu-favorite-load-more]').data('offset', $('a[data-wpgu-favorite-load-more]').data('offset') - 1);
                        }
                    }
                }

                window.wpguGtmTrackEvent( 'wpgu-favorite-button', 'removed favorite post', label );
            }

            if (result.data.favorite_added && result.data.favorite_added_html) {
                if ($('[data-wpgu-favorite-posts-container]').length) {
                    $('[data-wpgu-favorite-posts-container]').prepend(result.data.favorite_added_html);
                    $(document).trigger("wpgu-set-favorites-selected");

                    if ($('a[data-wpgu-favorite-load-more]').length) {
                        $('a[data-wpgu-favorite-load-more]').data('offset', $('a[data-wpgu-favorite-load-more]').data('offset') + 1);
                    }
                }

                window.wpguGtmTrackEvent('wpgu-favorite-button', 'added favorite post', label);
            }
        });
    });


    /*
        * Load the list of favorite items using AJAX
        */
    if ($('[data-wpgu-favorite-posts-container]').length) {

        let $container   = $('[data-wpgu-favorite-posts-container]'),
            offset       = $container.data( 'offset' ),
            amount       = $container.data( 'amount' );

        $.ajax( {
            url      : wpguvars.ajaxurl,
            data     : {
                action: 'wpgu_get_favorite_items',
                post_id: wpguvars.post_id,
                offset: offset,
                amount: amount
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( response ) {
            // redirect if needed
            if (response.data.redirect_url) {
                window.location.replace(response.data.redirect_url);
            }

            if ( true !== response.success || 0 === response.data.posts_total ) {
                console.warn( 'No posts found' );
                return;
            }

            $container.append(response.data.posts);

            if (response.data.posts_total > 6 && $('[data-wpgu-favorite-load-more-container]').length) {
                $('[data-wpgu-favorite-load-more-container]').removeClass('d-none');
            }

            $( document ).trigger( "wpgu-set-favorites-selected" );
        });
    }


    /*
        * Load more favorite items using AJAX
        */
    $( document ).on( 'click', 'a[data-wpgu-favorite-load-more]', function ( event ) {
        event.preventDefault();

        if( !$( '[data-wpgu-favorite-load-more-target]' ).length ) {
            console.warn( 'Load more target not found' );
            return false;
        }

        if ( $( '[data-wpgu-loading-icon]' ).length ) {
            return false;
        }

        var $button      = $(event.target),
            loadingtxt   = $button.data( 'loadingtxt' ),
            normaltxt    = $button.text(),
            title        = $button.attr( 'title' ),
            offset       = $button.data( 'offset' ),
            amount       = $button.data( 'amount' );

        $button.html( loadingtxt );
        $button.removeClass( 'has-error' );
        $button.addClass( 'is-loading' );

        $.ajax( {
            url      : wpguvars.ajaxurl,
            data     : {
                action: 'wpgu_load_more_favorite_items',
                post_id: wpguvars.post_id,
                offset: offset,
                amount: amount,
                title: title
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( response ) {

            $button.text( normaltxt );
            $button.removeClass( 'is-loading' );

            if ( true !== response.success || 0 === response.data.posts_total ) {
                $button.addClass( 'has-error' );
                console.warn( 'No posts found' );
                return;
            }

            $( '[data-wpgu-favorite-load-more-target]' ).append( response.data.posts );

            var newoffset = offset + amount;
            if( typeof $button.data( 'offset' ) !== 'undefined' ) {
                $button.data( 'offset', newoffset );
            }

            if( newoffset >= parseInt( response.data.posts_total ) ) {
                $( '[data-wpgu-favorite-load-more-container]' ).html("");
            }

            $( document ).trigger( "wpgu-set-favorites-selected" );
        });
    });
}); // close DOM ready
